// Full-document render of the tempurpedic OrderIssuePage LANDING ("thank
// you") state, shown after a successful submission (and via the admin
// "landing" preview / the puppeteer `--submitted` fixture). Same shell as
// OrderIssuePageTemplate -- header_content stream, the contact-us-container
// section, footer_content stream -- but the section holds ONLY the thank-you
// rich text, and the `.l-capped-width` wrapper drops the `order-issue-container`
// class (only the form template carries it; this is an intentional
// divergence, not an oversight).
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { buildToolboxPageMap } from "../blocks/toolboxPageMap";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes
// PageSkeleton, which is typed with mutable reactivated props (see
// PageSkeleton).
type IProps = templates.OrderIssuePageLandingTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    const toolboxMap = buildToolboxPageMap({
        hardcoded_ssr: props.hardcoded_ssr,
        hotspot_ssr: props.hotspot_ssr,
        breadcrumbs_ssr: props.breadcrumbs_ssr,
        customer_service_ssr: props.customer_service_ssr,
        shop_compare_ssr: props.shop_compare_ssr,
        tab_feature_attribute_ssr: props.tab_feature_attribute_ssr,
        reviews_ssr: props.reviews_ssr,
    });
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            {/* {% block extra_meta %}: React 19 hoists this into <head>. */}
            <meta name="chatTags" content="contact" />
            <div className="l-capped-width">
                <StreamField
                    tagName={React.Fragment}
                    value={props.page.header_content.value}
                    components={toolboxMap}
                />

                <div className="contact-us-container">
                    <section>
                        <div
                            className="rich-text"
                            dangerouslySetInnerHTML={{
                                __html: props.thank_you_html,
                            }}
                        />
                    </section>
                </div>

                <StreamField
                    tagName={React.Fragment}
                    value={props.page.footer_content.value}
                    components={toolboxMap}
                />
            </div>
        </PageSkeleton>
    );
};
